module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('gs-header', {
    attrs: {
      "title": "Sửa ngân hàng",
      "breadcrumbs": [{
        title: 'Quản lý ngân hàng',
        route: {
          name: 'bank'
        }
      }]
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "padding-sm-all"
  }, [_c('el-form', {
    ref: "create-bank-form",
    staticClass: "margin-top",
    attrs: {
      "label-position": "top",
      "rules": _vm.rules,
      "model": _vm.localBank,
      "label-width": "150px"
    },
    nativeOn: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.validatorBeforeSubmit.apply(null, arguments)
      }
    }
  }, [_c('el-row', {
    staticClass: "remove-margin",
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Tên",
      "prop": "name"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Tên"
    },
    model: {
      value: (_vm.localBank.name),
      callback: function($$v) {
        _vm.$set(_vm.localBank, "name", $$v)
      },
      expression: "localBank.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Tên rút gọn",
      "prop": "short_name"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Tên rút gọn"
    },
    model: {
      value: (_vm.localBank.short_name),
      callback: function($$v) {
        _vm.$set(_vm.localBank, "short_name", $$v)
      },
      expression: "localBank.short_name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Url"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Url"
    },
    model: {
      value: (_vm.localBank.url),
      callback: function($$v) {
        _vm.$set(_vm.localBank, "url", $$v)
      },
      expression: "localBank.url"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Logo"
    }
  }, [_c('el-upload', {
    staticClass: "avatar-uploader",
    attrs: {
      "action": _vm.uploadLogoUrl,
      "headers": _vm.uploadHeader,
      "show-file-list": false,
      "on-success": _vm.handleLogoUpload,
      "before-upload": _vm.beforeLogoUpload
    }
  }, [(_vm.logo.path) ? _c('img', {
    staticClass: "avatar",
    attrs: {
      "src": _vm.logo.path
    }
  }) : _c('i', {
    staticClass: "el-icon-plus avatar-uploader-icon"
  })])], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    staticClass: "remove-margin",
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('button', {
    staticClass: "ui blue basic small button",
    attrs: {
      "disabled": _vm.submitting,
      "native-type": "submit"
    }
  }, [_c('i', {
    staticClass: "fa fa-floppy-o"
  }), _vm._v(" Lưu lại")])])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-bb7cc672"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/bank/EditBank.vue
// module id = 732
// module chunks = 1